import React from 'react';
import '../css/Button.css'



const Button = ({ href }) => {

    return (

        <a
            href={href}
            target='_blank'
            rel='noopener noreferrer'
        >
            <button className="cta">
                COMPRE AGORA
            </button>
        </a>
    )

}

export default Button;
